/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_No_UsersInputs */

const en_admin_users_no_users = /** @type {(inputs: Admin_Users_No_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No users yet`)
};

/**
* | output |
* | --- |
* | "No users yet" |
*
* @param {Admin_Users_No_UsersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_users_no_users = /** @type {((inputs?: Admin_Users_No_UsersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_No_UsersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_users_no_users(inputs)
});
export { admin_users_no_users as "admin.users.no_users" }